import { render, staticRenderFns } from "./Feriados.vue?vue&type=template&id=8788a9b2"
import script from "./Feriados.vue?vue&type=script&lang=ts"
export * from "./Feriados.vue?vue&type=script&lang=ts"
import style0 from "./Feriados.vue?vue&type=style&index=0&id=8788a9b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports